import * as React from "react";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { Icon, Descriptions } from "antd";
import { StreamingClientAccountResources } from "../ClientAccountResources/StreamingClientAccountResources";
import { FormattedCurrency } from "../Localisation/FormattedCurrency";
import { AccountResources } from "swan-public-api-client";

interface Props extends WrappedComponentProps {}

class AccountSelectorClientAccountDescriptionCmp extends React.PureComponent<Props> {
  public render() {
    return (
      <div className="client-account-resources">
        <Icon type="team" />
        <StreamingClientAccountResources>
          {(currency, clientAccountResources) =>
            <Descriptions title={this.props.intl.formatMessage({ id: "accountSelector.clientAccountTitle" })}>
              <Descriptions.Item label={this.props.intl.formatMessage({ id: "clientAccountResources.openPnL" })}>
                <FormattedCurrency value={clientAccountResources ? clientAccountResources.OpenPnl : undefined} currency={currency} />
              </Descriptions.Item>
              <Descriptions.Item label={this.props.intl.formatMessage({ id: "clientAccountResources.marginRequirement" })}>
                <FormattedCurrency value={clientAccountResources ? clientAccountResources.MarginRequirement : undefined} currency={currency} />
              </Descriptions.Item>
              <Descriptions.Item label={this.props.intl.formatMessage({ id: "clientAccountResources.netOpenPositions" })}>
                <FormattedCurrency value={clientAccountResources ? clientAccountResources.NetOpenPosition : undefined} currency={currency} />
              </Descriptions.Item>
              <Descriptions.Item label={this.props.intl.formatMessage({ id: "clientAccountResources.netOpenPositionsLimit" })}>
                <FormattedCurrency value={clientAccountResources ? clientAccountResources.NetOpenPositionLimit : undefined} currency={currency} />
              </Descriptions.Item>
              <Descriptions.Item label={this.props.intl.formatMessage({ id: "clientAccountResources.netOpenPositionsAvailable" })}>
                <FormattedCurrency value={this.calculateNetOpenPositionAvailable(clientAccountResources)} currency={currency} />
              </Descriptions.Item>
              <Descriptions.Item label={this.props.intl.formatMessage({ id: "clientAccountResources.cashBalance" })}>
                <FormattedCurrency value={clientAccountResources ? clientAccountResources.CashBalance : undefined} currency={currency} />
              </Descriptions.Item>
            </Descriptions>
          }
        </StreamingClientAccountResources>
      </div>
    );
  }

  private calculateNetOpenPositionAvailable(clientAccountResources: AccountResources | undefined) {
    if (clientAccountResources === undefined) {
      return undefined;
    }

    if (clientAccountResources.NetOpenPositionLimit === undefined) {
      return undefined;
    }

    return clientAccountResources.NetOpenPositionLimit - clientAccountResources.NetOpenPosition;
  }
}

export const AccountSelectorClientAccountDescription = injectIntl(AccountSelectorClientAccountDescriptionCmp);
